module.exports = __webpack_public_path__ + "img/w3_store_black.511b889d.png";